<template>
  <el-card class="box-card" style="height:98%" :body-style="{ height: '100%' }">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span style="font-size: 24px">智能装备&nbsp;&nbsp;{{
        this.$route.meta.name
      }}&nbsp;&nbsp;数据配置</span>
    </div>
    <el-main>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="item" v-for="(item, index) in MenuList" :key="index" :name="item">
          <div class="flex" style="width: 100%;justify-content: space-between;" v-if="index == 0">
            <el-input style="width:30%" placeholder="输入关键字" size="normal" v-model="query" @input="GetChartsData(10)"
              clearable></el-input>
            <el-button type="primary" size="default" @click="addLabor = true">添加</el-button>
          </div>
          <div class="flex" style="width: 100%;justify-content: space-between;" v-else-if="index == 6">
            <el-input style="width:30%" placeholder="输入关键字" size="normal" v-model="query" @input="GetChartsData(14)"
              clearable></el-input>
            <el-button type="primary" size="default" @click="addLabor_7 = true">添加</el-button>
          </div>
          <div class="flex" style="width: 100%;justify-content: space-between;" v-else-if="index == 1">
            <el-form class="flex" :model="form" ref="form" label-width="80px" :inline="false" size="normal">
              <el-form-item label="横轴单位:">
                <el-input style="width:100%" placeholder="例如：日期" size="normal" v-model="zx" clearable></el-input>
              </el-form-item>
              <el-form-item label="纵轴单位:">
                <el-input style="width:100%" placeholder="例如：m³" size="normal" v-model="lx" clearable></el-input>
              </el-form-item>
              <el-form-item label-width="20px">
                <el-button type="primary" size="default" @click="Save(11)">保存</el-button>
              </el-form-item>
            </el-form>
            <div class="flex">
              <!-- <el-button type="primary" size="default">导入</el-button> -->
              <el-button type="primary" size="default" @click="addLabor_2 = true">添加</el-button>
            </div>
          </div>
          <div class="flex" style="width: 100%;justify-content: space-between;" v-else-if="index == 2">
            <el-form class="flex" :model="form" ref="form" label-width="80px" :inline="false" size="normal">
              <el-form-item label="横轴单位:">
                <el-input style="width:100%" placeholder="例如：日期" size="normal" v-model="zx" clearable></el-input>
              </el-form-item>
              <el-form-item label="纵轴单位:">
                <el-input style="width:100%" placeholder="例如：m³" size="normal" v-model="lx" clearable></el-input>
              </el-form-item>
              <el-form-item label-width="20px">
                <el-button type="primary" size="default" @click="Save(12)">保存</el-button>
              </el-form-item>
            </el-form>
            <div class="flex">
              <!-- <el-button type="primary" size="default">导入</el-button> -->
              <el-button type="primary" size="default" @click="addLabor_3 = true">添加</el-button>
            </div>
          </div>
          <div class="flex" style="width: 100%;justify-content: space-between;" v-else-if="index == 4">
            <el-form class="flex" :model="form" ref="form" label-width="80px" :inline="false" size="normal">
              <el-form-item label="横轴单位:">
                <el-input style="width:100%" placeholder="例如：日期" size="normal" v-model="zx" clearable></el-input>
              </el-form-item>
              <el-form-item label="纵轴单位:">
                <el-input style="width:100%" placeholder="例如：m³" size="normal" v-model="lx" clearable></el-input>
              </el-form-item>
              <el-form-item label-width="20px">
                <el-button type="primary" size="default" @click="Save(13)">保存</el-button>
              </el-form-item>
            </el-form>
            <div class="flex">
              <!-- <el-button type="primary" size="default">导入</el-button> -->
              <el-button type="primary" size="default" @click="addLabor_5 = true">添加</el-button>
            </div>
          </div>
          <div class="flex" style="width: 100%;justify-content: space-between;" v-else-if="index == 5">
            <el-input style="width:30%" v-model="query" @input="GetCustomTable(5)" placeholder="输入关键字" size="normal"
              clearable></el-input>
            <el-button type="primary" size="default" @click="showAddLabor_6">添加</el-button>
          </div>
          <div class="flex" style="width: 100%;justify-content: space-between;" v-else-if="index == 7">
            <el-input style="width:30%" placeholder="请输入关键字" @input="GetCustomTable(6)" v-model="query" size="normal"
              clearable></el-input>

            <div class="flex">
              <!-- <el-button type="primary" size="default">导入</el-button> -->
              <el-button type="primary" size="default" @click="addLabor_8 = true">添加</el-button>
            </div>
          </div>
          <div class="flex" style="width: 100%;justify-content: right;" v-else-if="index == 3">
            <el-button type="primary" size="default" @click="() => {
              addLabor_4 = true;
              GetProjectModelList();
            }
              ">添加</el-button>
          </div>
          <div class="flex" style="width: 100%;justify-content: space-between;" v-else>
            <el-input style="width:30%" placeholder="输入关键字" size="normal" clearable></el-input>
            <el-button type="primary" size="default" @click="addLabor = true">添加</el-button>
          </div>

          <el-table v-if="index == 0" height="540" :data="tableData" align="center" style="width: 100%">
            <el-table-column type="index" align="center" label="序号" width="80">
            </el-table-column>
            <el-table-column prop="csdt05" align="center" label="参数名称">
            </el-table-column>
            <el-table-column prop="csdt06" align="center" label="参数值">
            </el-table-column>
            <el-table-column prop="user04" align="center" label="添加人">
              <template slot-scope="scope">
                <div>
                  毕小埃
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="csdt09" align="center" label="添加时间">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="small" style="margin-right:10px" @click="
                  addLabor = true;
                list = [{ ...scope.row }];
                ">编辑</el-button>
                <el-popconfirm @confirm="DelChartsData(scope.row, 10)" title="这是一段内容确定删除吗？">
                  <el-button size="small" type="danger" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>

          <el-table v-if="index == 6" height="540" :data="tableData" align="center" style="width: 100%">
            <el-table-column type="index" align="center" label="序号" width="80">
            </el-table-column>
            <el-table-column prop="csdt05" align="center" label="参数名称">
            </el-table-column>
            <el-table-column prop="csdt06" align="center" label="参数值">
            </el-table-column>
            <el-table-column prop="user04" align="center" label="添加人">
            </el-table-column>
            <el-table-column prop="csdt09" align="center" label="添加时间">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="small" style="margin-right:10px" @click="
                  addLabor_7 = true;
                list_7 = [{ ...scope.row }];
                ">编辑</el-button>
                <el-popconfirm @confirm="DelChartsData(scope.row, 14)" title="这是一段内容确定删除吗？">
                  <el-button size="small" type="danger" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>

          <el-table v-if="index == 1" height="540" :data="tableData.filter((el) => el.csdt04 != 1)" align="center"
            style="width: 100%">
            <el-table-column type="index" align="center" label="序号">
            </el-table-column>
            <el-table-column prop="csdt05" align="center" label="横轴">
            </el-table-column>
            <el-table-column prop="csdt06" align="center" label="纵轴">
            </el-table-column>
            <el-table-column prop="user04" align="center" label="添加人">
            </el-table-column>
            <el-table-column prop="csdt09" align="center" label="添加时间">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="small" style="margin-right:10px" @click="() => {
                  addLabor_2 = true;
                  list_2 = [{ ...scope.row }];
                }
                  ">编辑</el-button>
                <el-popconfirm @confirm="DelChartsData(scope.row, 11)" title="这是一段内容确定删除吗？">
                  <el-button size="small" type="danger" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-table v-if="index == 2" height="540" :data="tableData.filter((el) => el.csdt04 != 1)" align="center"
            style="width: 100%">
            <el-table-column type="index" align="center" label="序号">
            </el-table-column>
            <el-table-column prop="csdt05" align="center" label="横轴">
            </el-table-column>
            <el-table-column prop="csdt06" align="center" label="纵轴">
            </el-table-column>
            <el-table-column prop="user04" align="center" label="添加人">
            </el-table-column>
            <el-table-column prop="csdt09" align="center" label="添加时间">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="small" style="margin-right:10px" @click="() => {
                  addLabor_3 = true;
                  list_3 = [{ ...scope.row }];
                }
                  ">编辑</el-button>
                <el-popconfirm @confirm="DelChartsData(scope.row, 12)" title="这是一段内容确定删除吗？">
                  <el-button size="small" type="danger" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-table v-if="index == 3" height="540" :data="tableData" align="center" style="width: 100%">
            <el-table-column type="index" align="center" label="序号">
            </el-table-column>
            <el-table-column prop="mtma03" align="center" label="标签名">
            </el-table-column>
            <el-table-column prop="value" align="center" label="多媒体类型">
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.mtma04 == 1
                    ? "视频"
                    : scope.row.mtma04 == 2
                      ? "图片"
                      : "模型"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="user04" align="center" label="发布人">
            </el-table-column>
            <el-table-column prop="mtma07" align="center" label="发布时间">
            </el-table-column>
            <el-table-column label="操作" align="center" width="340">
              <template slot-scope="scope">
                <el-button type="primary" size="small" @click="LookmenuList(scope.row)">查看</el-button>
                <el-button type="primary" size="small" @click="MoveMultimedia(scope.row, 1)">上移</el-button>
                <el-button type="primary" size="small" style="margin-right:10px"
                  @click="MoveMultimedia(scope.row, 2)">下移</el-button>
                <el-popconfirm @confirm="DelMultimedia(scope.row)" title="这是一段内容确定删除吗？">
                  <el-button size="small" type="danger" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>

          <el-table v-if="index == 4" height="540" :data="tableData.filter((el) => el.csdt04 != 1)" align="center"
            style="width: 100%">
            <el-table-column type="index" align="center" label="序号">
            </el-table-column>
            <el-table-column prop="csdt05" align="center" label="横轴">
            </el-table-column>
            <el-table-column prop="csdt06" align="center" label="纵轴">
            </el-table-column>
            <el-table-column prop="user04" align="center" label="添加人">
            </el-table-column>
            <el-table-column prop="csdt09" align="center" label="添加时间">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="small" style="margin-right:10px" @click="() => {
                  addLabor_5 = true;
                  list_5 = [{ ...scope.row }];
                }
                  ">编辑</el-button>
                <el-popconfirm @confirm="DelChartsData(scope.row, 13)" title="这是一段内容确定删除吗？">
                  <el-button size="small" type="danger" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>

          <el-table v-if="index == 5" height="540" :data="tableData" align="center" style="width: 100%">
            <el-table-column type="index" align="center" label="序号" width="80">
            </el-table-column>
            <el-table-column prop="name" align="center" label="设备编号" width="190">
              <template slot="header" slot-scope="scope">
                <span @click="setHeader(scope.$index, '装饰装修工程第六模块')">{{ TableListHead_6[0] }}</span>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ scope.row.cmtb05 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="value" align="center" label="">
              <template slot="header" slot-scope="scope">
                <span @click="setHeader(scope.$index, '装饰装修工程第六模块')">{{ TableListHead_6[1] }}</span>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ scope.row.cmtb06 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="user" align="center" label="" width="80">
              <template slot="header" slot-scope="scope">
                <span @click="setHeader(scope.$index, '装饰装修工程第六模块')">{{ TableListHead_6[2] }}</span>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ scope.row.cmtb07 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="date" align="center" label="">
              <template slot="header" slot-scope="scope">
                <span @click="setHeader(scope.$index, '装饰装修工程第六模块')">{{ TableListHead_6[3] }}</span>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ scope.row.cmtb08 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="date" align="center" label="">
              <template slot="header" slot-scope="scope">
                <span @click="setHeader(scope.$index, '装饰装修工程第六模块')">{{ TableListHead_6[4] }}</span>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ scope.row.cmtb09 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="date" align="center" label="">
              <template slot="header" slot-scope="scope">
                <span @click="setHeader(scope.$index, '装饰装修工程第六模块')">{{ TableListHead_6[5] }}</span>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ scope.row.cmtb10 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="date" align="center" label="发布人">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.user04 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="date" align="center" label="发布时间">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.cmtb12 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="primary" style="margin-right:10px" size="small" @click="Eidt(scope.row)">编辑</el-button>
                <el-popconfirm @confirm="Delete(scope.row)" title="这是一段内容确定删除吗？">
                  <el-button size="small" type="danger" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-table v-if="index == 7" height="540" :data="tableData" align="center" style="width: 100%">
            <el-table-column type="index" align="center" label="序号" width="80">
            </el-table-column>
            <el-table-column prop="name" align="center" width="190">
              <template slot="header" slot-scope="scope">
                <span @click="setHeader(scope.$index, '装饰装修工程第八模块')">{{ TableListHead_8[0] }}</span>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ scope.row.cmtb05 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="value" align="center" label="">
              <template slot="header" slot-scope="scope">
                <span @click="setHeader(scope.$index, '装饰装修工程第八模块')">{{ TableListHead_8[1] }}</span>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ scope.row.cmtb06 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="user" align="center" label="" width="80">
              <template slot="header" slot-scope="scope">
                <span @click="setHeader(scope.$index, '装饰装修工程第八模块')">{{ TableListHead_8[2] }}</span>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ scope.row.cmtb07 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="date" align="center" label="">
              <template slot="header" slot-scope="scope">
                <span @click="setHeader(scope.$index, '装饰装修工程第八模块')">{{ TableListHead_8[3] }}</span>
              </template>
              <template slot-scope="scope">
                <div>
                  {{ scope.row.cmtb08 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="date" align="center" label="发布人">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.user04 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="date" align="center" label="发布时间">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.cmtb12 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="primary" style="margin-right:10px" size="small" @click="
                  addLabor_8 = true;
                cmtb_8 = [{ ...scope.row }];
                ">编辑</el-button>
                <el-popconfirm @confirm="Delete(scope.row, 6)" title="这是一段内容确定删除吗？">
                  <el-button size="small" type="danger" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>

          <div style="display: flex;align-items: center;justify-content: space-around;">
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
              :page-count="pageIndex" @current-change="CurrentChange">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <el-dialog :close-on-click-modal="false" title="添加" @close="() => {
      list = [{
        csdt01: 0,
        csdt02: $store.state.xid,
        csdt03: 10,
        csdt04: 2,
        csdt05: '',
        csdt06: '',
      }]
    }" :visible.sync="addLabor">
      <el-row style="text-align: center;">
        <el-col :span="7">参数名称</el-col>
        <el-col :span="7" :offset="1">参数值</el-col>
        <el-col :span="7" :offset="1"></el-col>
      </el-row>

      <el-row v-for="(item, index) in list" :key="index">
        <el-col :span="7">
          <el-input v-model="item.csdt05" placeholder="标题"></el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-input v-model="item.csdt06" placeholder="内容"></el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <i class="el-icon-circle-plus-outline" style="
                    font-size: 30px;
                    color: green;
                    margin-right: 20px;" @click="
                      list.push({
                        csdt01: 0,
                        csdt02: $store.state.xid,
                        csdt03: 10,
                        csdt04: 2,
                        csdt05: '',
                        csdt06: '',
                      })
                      "></i>
          <i class=" el-icon-remove-outline" v-if="list.length > 1" style="font-size: 30px; color: red"
            @click="list.splice(index, 1)"></i>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="2" :offset="10">
          <el-button type="primary" @click="addTreeTableData(list, 10)">确定</el-button>
        </el-col>
        <el-col :span="2" :offset="2">
          <el-button type="danger" @click="addLabor = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="添加" @close="() => {
      cmtb_8 = [{
        cmtb01: 0,
        cmtb02: $store.state.xid,
        cmtb03: 6,
        cmtb04: null,
        cmtb05: '',
        cmtb06: '',
        cmtb07: '',
        cmtb08: '',
        cmtb09: '',
        cmtb10: '',
      }]
    }" :visible.sync="addLabor_8">
      <el-row style="text-align: center;">
        <el-col :span="4" :offset="1">{{ TableListHead_8[0] }}</el-col>
        <el-col :span="4" :offset="1">{{ TableListHead_8[1] }}</el-col>
        <el-col :span="4" :offset="1">{{ TableListHead_8[2] }}</el-col>
        <el-col :span="4" :offset="1">{{ TableListHead_8[3] }}</el-col>
        <el-col :span="4"></el-col>
      </el-row>

      <el-row v-for="(item, index) in cmtb_8" :key="index">
        <el-col :span="4" offset="1">
          <el-input v-model="item.cmtb05" placeholder="内容"></el-input>
        </el-col>
        <el-col :span="4" offset="1">
          <el-input v-model="item.cmtb06" placeholder="内容"></el-input>
        </el-col>
        <el-col :span="4" offset="1">
          <el-input v-model="item.cmtb07" placeholder="内容"></el-input>
        </el-col>
        <el-col :span="4" offset="1">
          <el-input v-model="item.cmtb08" placeholder="内容"></el-input>
        </el-col>
        <el-col :span="4">
          <i class="el-icon-circle-plus-outline" style="
                    font-size: 30px;
                    color: green;
                    margin-right: 20px;" @click="
                      cmtb_8.push({
                        cmtb01: 0,
                        cmtb02: $store.state.xid,
                        cmtb03: 6,
                        cmtb04: null,
                        cmtb05: '',
                        cmtb06: '',
                        cmtb07: '',
                        cmtb08: '',
                        cmtb09: '',
                        cmtb10: '',
                      })
                      "></i>
          <i class=" el-icon-remove-outline" v-if="cmtb_8.length > 1" style="font-size: 30px; color: red"
            @click="cmtb_8.splice(index, 1)"></i>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="2" :offset="10">
          <el-button type="primary" @click="cmtb_8_list">确定</el-button>
        </el-col>
        <el-col :span="2" :offset="2">
          <el-button type="danger" @click="addLabor_8 = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="添加" @close="() => {
      list_7 = [{
        csdt01: 0,
        csdt02: $store.state.xid,
        csdt03: 14,
        csdt04: 2,
        csdt05: '',
        csdt06: '',
      }]
    }" :visible.sync="addLabor_7">
      <el-row style="text-align: center;">
        <el-col :span="7">参数名称</el-col>
        <el-col :span="7" :offset="1">参数值</el-col>
        <el-col :span="7" :offset="1"></el-col>
      </el-row>

      <el-row v-for="(item, index) in list_7" :key="index">
        <el-col :span="7">
          <el-input v-model="item.csdt05" placeholder="标题"></el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-input v-model="item.csdt06" placeholder="内容"></el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <i class="el-icon-circle-plus-outline" style="
                    font-size: 30px;
                    color: green;
                    margin-right: 20px;" @click="
                      list_7.push({
                        csdt01: 0,
                        csdt02: $store.state.xid,
                        csdt03: 14,
                        csdt04: 2,
                        csdt05: '',
                        csdt06: '',
                      })
                      "></i>
          <i class=" el-icon-remove-outline" v-if="list_7.length > 1" style="font-size: 30px; color: red"
            @click="list_7.splice(index, 1)"></i>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="2" :offset="10">
          <el-button type="primary" @click="addTreeTableData(list_7, 14)">确定</el-button>
        </el-col>
        <el-col :span="2" :offset="2">
          <el-button type="danger" @click="addLabor_7 = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="添加" @close="() => {
      list_2 = [{
        csdt01: 0,
        csdt02: $store.state.xid,
        csdt03: 11,
        csdt04: 2,
        csdt05: '',
        csdt06: '',
      }]
    }" :visible.sync="addLabor_2">
      <el-row style="text-align: center;">
        <el-col :span="7">横轴</el-col>
        <el-col :span="7" :offset="1">纵轴</el-col>
        <el-col :span="7" :offset="1"></el-col>
      </el-row>

      <el-row v-for="(item, index) in list_2" :key="index">
        <el-col :span="7">
          <el-input v-model="item.csdt05" placeholder="标题"></el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-input v-model="item.csdt06" placeholder="内容"></el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <i class="el-icon-circle-plus-outline" style="
                    font-size: 30px;
                    color: green;
                    margin-right: 20px;" @click="
                      list_2.push({
                        csdt01: 0,
                        csdt02: $store.state.xid,
                        csdt03: 11,
                        csdt04: 2,
                        csdt05: '',
                        csdt06: '',
                      })
                      "></i>
          <i class=" el-icon-remove-outline" v-if="list_2.length > 1" style="font-size: 30px; color: red"
            @click="list_2.splice(index, 1)"></i>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="2" :offset="10">
          <el-button type="primary" @click="addTreeTableData(list_2, 11)">确定</el-button>
        </el-col>
        <el-col :span="2" :offset="2">
          <el-button type="danger" @click="addLabor_2 = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="添加" @close="() => {
      list_3 = [{
        csdt01: 0,
        csdt02: $store.state.xid,
        csdt03: 12,
        csdt04: 2,
        csdt05: '',
        csdt06: '',
      }]
    }" :visible.sync="addLabor_3">
      <el-row style="text-align: center;">
        <el-col :span="7">横轴</el-col>
        <el-col :span="7" :offset="1">纵轴</el-col>
        <el-col :span="7" :offset="1"></el-col>
      </el-row>

      <el-row v-for="(item, index) in list_3" :key="index">
        <el-col :span="7">
          <el-input v-model="item.csdt05" placeholder="标题"></el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-input v-model="item.csdt06" placeholder="内容"></el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <i class="el-icon-circle-plus-outline" style="
                    font-size: 30px;
                    color: green;
                    margin-right: 20px;" @click="
                      list_3.push({
                        csdt01: 0,
                        csdt02: $store.state.xid,
                        csdt03: 12,
                        csdt04: 2,
                        csdt05: '',
                        csdt06: '',
                      })
                      "></i>
          <i class=" el-icon-remove-outline" v-if="list_3.length > 1" style="font-size: 30px; color: red"
            @click="list_3.splice(index, 1)"></i>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="2" :offset="10">
          <el-button type="primary" @click="addTreeTableData(list_3, 12)">确定</el-button>
        </el-col>
        <el-col :span="2" :offset="2">
          <el-button type="danger" @click="addLabor_3 = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="添加" @close="() => {
      list_5 = [{
        csdt01: 0,
        csdt02: $store.state.xid,
        csdt03: 13,
        csdt04: 2,
        csdt05: '',
        csdt06: '',
      }]
    }" :visible.sync="addLabor_5">
      <el-row style="text-align: center;">
        <el-col :span="7">横轴</el-col>
        <el-col :span="7" :offset="1">纵轴</el-col>
        <el-col :span="7" :offset="1"></el-col>
      </el-row>

      <el-row v-for="(item, index) in list_5" :key="index">
        <el-col :span="7">
          <el-input v-model="item.csdt05" placeholder="标题"></el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-input v-model="item.csdt06" placeholder="内容"></el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <i class="el-icon-circle-plus-outline" style="
                    font-size: 30px;
                    color: green;
                    margin-right: 20px;" @click="
                      list_5.push({
                        csdt01: 0,
                        csdt02: $store.state.xid,
                        csdt03: 13,
                        csdt04: 2,
                        csdt05: '',
                        csdt06: '',
                      })
                      "></i>
          <i class=" el-icon-remove-outline" v-if="list_5.length > 1" style="font-size: 30px; color: red"
            @click="list_5.splice(index, 1)"></i>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="2" :offset="10">
          <el-button type="primary" @click="addTreeTableData(list_5, 13)">确定</el-button>
        </el-col>
        <el-col :span="2" :offset="2">
          <el-button type="danger" @click="addLabor_5 = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="添加/修改" :visible.sync="addLabor_4">
      <el-row style="text-align: center;">
        <el-col :span="7">标签名</el-col>
        <el-col :span="6" :offset="1">选择类型</el-col>
        <el-col :span="7" :offset="1">上传/选择</el-col>
      </el-row>

      <el-row>
        <el-form :model="cmtb_4" ref="form_4" label-width="0px" :inline="false" size="normal">
          <el-col :span="7">
            <el-form-item prop="mtma03" :rules="[
              { required: true, message: '请输入标签名', trigger: 'blur' },
            ]" label="">
              <el-input v-model="cmtb_4.mtma03" placeholder="请输入文字,仅限8个汉字"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item :rules="[
              { required: true, message: '请选择类型', trigger: 'change' },
            ]" label="" prop="mtma04">
              <el-select v-model="cmtb_4.mtma04" placeholder="选择类型" clearable filterable>
                <el-option v-for="item in [
                  { label: '图片', value: 2 },
                  { label: '视频', value: 1 },
                  { label: '模型', value: 3 },
                ]" :key="item.value" :label="item.label" :value="item.value">
                </el-option> </el-select></el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item :rules="[
              { required: true, message: '请选择', trigger: 'change' },
            ]" prop="mtma05" label="">
              <el-upload v-if="cmtb_4.mtma04 == 1" style="width:100%!important" class="upload-demo" accept=".mp4"
                :on-change="(file, fileList) => {
                  cmtb_4.mtma05 = file.raw;
                }
                  " :auto-upload="false" multiple :limit="1">
                <el-button size="small" type="primary" style="width:200px">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传mp4文件，且不超过1GB
                </div>
              </el-upload>
              <el-upload v-else-if="cmtb_4.mtma04 == 2" style="width:100%!important" class="upload-demo"
                accept=".jpeg,.jpg,.png,.gif" :on-change="(file, fileList) => {
                  cmtb_4.mtma05 = file.raw;
                }
                  " :auto-upload="false" multiple :limit="1">
                <el-button size="small" type="primary" style="width:200px">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
              <el-select v-else-if="cmtb_4.mtma04 == 3" v-model="cmtb_4.mtma05" placeholder="选择" clearable filterable>
                <el-option v-for="item in select_4" :key="item.mode01" :label="item.mode02" :value="item.mode09">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <el-row>
        <el-col :span="2" :offset="10">
          <el-button type="primary" @click="formName('form_4')">确定</el-button>
        </el-col>
        <el-col :span="2" :offset="2">
          <el-button type="danger" @click="addLabor_4 = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="新增/修改" :visible.sync="addLabor_6">
      <el-form ref="form" :model="cmtb_1" label-width="80px">
        <el-form-item :label="TableListHead_6[0]" label-width="120px">
          <el-input v-model="cmtb_1.cmtb05"></el-input>
        </el-form-item>
        <el-form-item :label="TableListHead_6[1]" label-width="120px">
          <el-input v-model="cmtb_1.cmtb06"></el-input>
        </el-form-item>
        <el-form-item :label="TableListHead_6[2]" label-width="120px">
          <el-input v-model="cmtb_1.cmtb07"></el-input>
        </el-form-item>
        <el-form-item :label="TableListHead_6[3]" label-width="120px">
          <el-input v-model="cmtb_1.cmtb08"></el-input>
        </el-form-item>
        <el-form-item :label="TableListHead_6[4]" label-width="120px">
          <el-input v-model="cmtb_1.cmtb09"></el-input>
        </el-form-item>
        <el-form-item :label="TableListHead_6[5]" label-width="120px">
          <el-input v-model="cmtb_1.cmtb10"></el-input>
        </el-form-item>
      </el-form>

      <el-row>
        <el-col :span="2" :offset="10">
          <el-button type="primary" @click="AddOrUpdateCustomTable(cmtb_1, 5)">确定</el-button>
        </el-col>
        <el-col :span="2" :offset="2">
          <el-button type="danger" @click="addLabor_6 = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <RunhongLookOver ref="Look"></RunhongLookOver>
  </el-card>
</template>
<script>
import {
  GetTitleSet,
  AddOrUpdateTitleSet,
  AddOrUpdateCustomTable,
  GetCustomTable,
  DelCoustomTable,
  AddOrUpdateChartsData,
  GetChartsData,
  GetMultimedia,
  AddOrUpdateMultimedia,
  DelMultimedia,
  MoveMultimedia,
  GetProjectModelList,
  DelChartsData,
  AddOrUpdateDPTreeData,
  DeleteDPTreeData,
  GetTreeData,
} from "@/setAxios.js";
import RunhongLookOver from "./lookOver";
export default {
  name: "",
  props: {},
  components: { RunhongLookOver },
  data() {
    return {
      query: "",
      select_4: [],
      cmtb_1: {
        cmtb01: 0,
        cmtb02: this.$store.state.xid,
        cmtb03: 5,
        cmtb04: null,
        cmtb05: "",
        cmtb06: "",
        cmtb07: "",
        cmtb08: "",
        cmtb09: "",
        cmtb10: "",
      },
      cmtb_8: [
        {
          cmtb01: 0,
          cmtb02: this.$store.state.xid,
          cmtb03: 6,
          cmtb04: null,
          cmtb05: "",
          cmtb06: "",
          cmtb07: "",
          cmtb08: "",
          cmtb09: "",
          cmtb10: "",
        },
      ],
      zx: "",
      lx: "",
      fileList: [],
      form_0: {},
      form: {},
      zNodeList: [],
      ZtreeItem: {
        name: "objectName",
        parentName: "parentId",
        id: "id",
      },
      MenuList: [
        "智能装备状态监测",
        "施工面积",
        "行驶里程",
        "中间多媒体",
        "施工功效在线监测",
        "智能装备参数",
        "智能装备故障报警",
        "智能装备使用记录",
      ],
      TableListHead_8: [],
      TableListHead_6: [],
      select: 1,
      activeName: "智能装备状态监测",
      tableData: [],
      addLabor: false,
      addLabor_2: false,
      addLabor_3: false,
      addLabor_4: false,
      addLabor_5: false,
      addLabor_6: false,
      addLabor_7: false,
      addLabor_8: false,
      addLabor_0: false,
      cmtb_4: {
        mtma01: 0,
        mtma02: this.$store.state.xid,
        mtma03: "",
        mtma04: null,
        mtma05: null,
        mtma09: 3,
      },
      list: [
        {
          csdt01: 0,
          csdt02: this.$store.state.xid,
          csdt03: 10,
          csdt04: 2,
          csdt05: "",
          csdt06: "",
        },
      ],
      list_2: [
        {
          csdt01: 0,
          csdt02: this.$store.state.xid,
          csdt03: 11,
          csdt04: 2,
          csdt05: "",
          csdt06: "",
        },
      ],
      list_3: [
        {
          csdt01: 0,
          csdt02: this.$store.state.xid,
          csdt03: 12,
          csdt04: 2,
          csdt05: "",
          csdt06: "",
        },
      ],
      list_5: [
        {
          csdt01: 0,
          csdt02: this.$store.state.xid,
          csdt03: 13,
          csdt04: 2,
          csdt05: "",
          csdt06: "",
        },
      ],
      list_7: [
        {
          csdt01: 0,
          csdt02: this.$store.state.xid,
          csdt03: 14,
          csdt04: 2,
          csdt05: "",
          csdt06: "",
        },
      ],
      count: 0,
      Name: "",
      pageSize: 10,
      pageIndex: 1,
      total: 0,
      typeT: 0,
    };
  },
  computed: {},
  watch: {},
  methods: {
    async cmtb_8_list() {
      for (let i = 0; i < this.cmtb_8.length; i++) {
        let form = new FormData();
        for (const key in this.cmtb_8[i]) {
          form.append(key, this.cmtb_8[i][key]);
        }
        let res = await AddOrUpdateCustomTable(form);
        this.$message.success("成功");
      }
      this.addLabor_8 = false;
      this.GetCustomTable(6);
      this.cmtb_8 = this.$options.data.call(this).cmtb_8;
    },
    CurrentChange(val) {
      this.pageIndex = val;
      this.GetChartsData(this.typeT, 2);
    },
    LookmenuList(item) {
      this.$refs.Look.Open(item);
    },
    showAddLabor_6() {
      this.addLabor_6 = true;
      this.cmtb_1 = this.$options.data.call(this).cmtb_1;
    },
    MoveMultimedia(item, type) {
      let formData = new FormData();
      formData.append("id", item.mtma01);
      formData.append("type", type);
      MoveMultimedia(formData).then((res) => {
        this.GetMultimedia();
      });
    },
    DelMultimedia(item) {
      let formData = new FormData();
      formData.append("id", item.cmtb01 || item.mtma01);
      DelMultimedia(formData).then((res) => {
        this.GetMultimedia();
      });
    },
    formName(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          if (this.cmtb_4.mtma04 == "2") {
            if (!this.$checkFile(this.cmtb_4.mtma05, "image")) {
              return false;
            }
          } else if (this.cmtb_4.mtma04 == "1") {
            if (!this.$checkFile(this.cmtb_4.mtma05, "video")) {
              return false;
            }
          }
          let formData = new FormData();
          for (const key in this.cmtb_4) {
            formData.append(key, this.cmtb_4[key]);
          }
          AddOrUpdateMultimedia(formData).then((res) => {
            this.$message.success("成功");
            this.GetMultimedia();
            this.cmtb_4 = this.$options.data.call(this).cmtb_4;
            this.addLabor_4 = false;
          });
        } else {
          return false;
        }
      });
    },
    GetProjectModelList() {
      this.cmtb_4 = this.$options.data.call(this).cmtb_4;
      GetProjectModelList({
        params: {
          xid: this.$store.state.xid,
          seachword: "",
          pageIndex: 1,
          pageSize: 1000,
        },
      }).then((res) => {
        this.select_4 = res.Data.list;
      });
    },
    GetMultimedia() {
      GetMultimedia({
        params: {
          xid: this.$store.state.xid,
          mtma09: 3,
        },
      }).then((res) => {
        this.tableData = res.Data;
      });
    },
    DelChartsData(item, type) {
      let formData = new FormData();
      formData.append("id", item.csdt01);
      DelChartsData(formData).then((res) => {
        this.GetChartsData(type);
      });
    },
    async addTreeTableData(list, type) {
      for (let i = 0; i < list.length; i++) {
        let form = new FormData();
        for (const key in list[i]) {
          form.append(key, list[i][key]);
        }
        let res = await AddOrUpdateChartsData(form);
        this.$message.success("成功");
      }
      this.addLabor = false;
      this.addLabor_2 = false;
      this.addLabor_3 = false;
      this.addLabor_5 = false;
      this.addLabor_7 = false;
      this.list = this.$options.data.call(this).list;
      this.list_2 = this.$options.data.call(this).list_2;
      this.list_3 = this.$options.data.call(this).list_3;
      this.list_5 = this.$options.data.call(this).list_5;
      this.list_7 = this.$options.data.call(this).list_7;
      this.GetChartsData(type);
    },
    GetChartsData(type, idType = "") {
      this.typeT = type;
      GetChartsData({
        params: {
          xid: this.$store.state.xid,
          csdt03: type,
          searchword: this.query,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          csdt04: idType
        },
      }).then((res) => {
        if (idType != 2) {
          this.zx = "";
          this.lx = "";
          if (res.Data.list.filter((el) => el.csdt04 == 1).length > 0) {
            this.zx = res.Data.list.filter((el) => el.csdt04 == 1)[0].csdt05;
            this.lx = res.Data.list.filter((el) => el.csdt04 == 1)[0].csdt06;
          }
        }
        this.tableData = res.Data.list;
        if (res.Data.list.filter((el) => el.csdt04 == 1).length > 0) {
          this.total = res.Data.total - 1;
        } else {
          this.total = res.Data.total;
        }
      });
    },
    Save(type) {
      let form = new FormData();
      let _this = this;
      var cmtb = {
        csdt01: 0,
        csdt02: this.$store.state.xid,
        csdt03: type,
        csdt04: 1,
        csdt05: _this.zx,
        csdt06: _this.lx,
      };
      if (this.tableData.filter((el) => el.csdt04 == 1).length > 0) {
        cmtb = Object.assign(this.tableData.filter((el) => el.csdt04 == 1)[0], {
          csdt05: _this.zx,
          csdt06: _this.lx,
        });
      }

      for (const key in cmtb) {
        form.append(key, cmtb[key]);
      }
      AddOrUpdateChartsData(form).then((res) => {
        this.$message.success("成功");
        this.GetChartsData(type);
      });
    },
    Save_2() {
      let form = new FormData();
      let _this = this;
      let cmtb = {
        cmtb01: 0,
        cmtb02: this.$store.state.xid,
        cmtb03: 2,
        cmtb04: null,
        cmtb05: _this.zx,
        cmtb06: _this.lx,
        cmtb07: "",
        cmtb08: "",
        cmtb09: "",
        cmtb10: "",
        cmtb13: "1",
      };
      for (const key in cmtb) {
        form.append(key, cmtb[key]);
      }
      AddOrUpdateCustomTable(form).then((res) => {
        _this.cmtb_1 = _this.$options.data.call(_this).cmtb_1;
        _this.cmtb_8 = _this.$options.data.call(_this).cmtb_8;
      });
    },
    FileChange(file, fileLis) {
      this.cmtb_1.cmtb04 = file.raw;
    },
    AddOrUpdateCustomTable(cmtb, type) {
      let form = new FormData();
      let _this = this;
      for (const key in cmtb) {
        form.append(key, cmtb[key]);
      }
      AddOrUpdateCustomTable(form).then((res) => {
        _this.addLabor_6 = false;
        _this.$message.success("成功");
        _this.GetCustomTable(type);
        _this.cmtb_1 = _this.$options.data.call(_this).cmtb_1;
      });
    },
    setHeader(index, name) {
      let _this = this;
      this.$prompt("请输入名称", "修改名称", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          AddOrUpdateTitleSet({
            tist02: _this.$store.state.xid,
            tist03: name,
            tist04: index,
            tist05: value,
          }).then((res) => {
            _this.GetTitleSet(true);
            _this.$message({
              type: "success",
              message: "修改为: " + value,
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消修改",
          });
        });
    },
    handleClick(tab, event) {
      let _this = this;
      this.pageIndex = 1;

      if (this.Name == tab.name) {
        this.count++;
        if (this.count % 2 == 0) {
          this.$prompt("请输入名称", "修改名称", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          })
            .then(({ value }) => {
              AddOrUpdateTitleSet({
                tist02: _this.$store.state.xid,
                tist03: "装饰装修工程模块",
                tist04:
                  _this.MenuList.indexOf(_this.activeName) == -1
                    ? Number(_this.activeName)
                    : _this.MenuList.indexOf(_this.activeName) + 1,
                tist05: value,
              }).then((res) => {
                _this.GetTitleSet(true);
                _this.$message({
                  type: "success",
                  message: "修改为: " + value,
                });
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "取消修改",
              });
            });
        } else {
        }
      }
      this.Name = tab.name;
      if (this.MenuList.indexOf(this.activeName) + 1 == 1) {
        this.GetChartsData(10);
      } else if (this.MenuList.indexOf(this.activeName) + 1 == 2) {
        this.GetChartsData(11);
      } else if (this.MenuList.indexOf(this.activeName) + 1 == 3) {
        this.GetChartsData(12);
      } else if (this.MenuList.indexOf(this.activeName) + 1 == 4) {
        this.GetMultimedia();
      } else if (this.MenuList.indexOf(this.activeName) + 1 == 5) {
        this.GetChartsData(13);
      } else if (this.MenuList.indexOf(this.activeName) + 1 == 6) {
        this.GetCustomTable(5);
      } else if (this.MenuList.indexOf(this.activeName) + 1 == 7) {
        this.GetChartsData(14);
      } else if (this.MenuList.indexOf(this.activeName) + 1 == 8) {
        this.GetCustomTable(6);
      } else {
      }
    },
    Eidt(item) {
      this.addLabor_6 = true;
      Object.assign(this.cmtb_1, item);
    },
    Delete(item, type) {
      DelCoustomTable({ id: item.cmtb01 }).then((res) => {
        this.$message.success("成功");
        if (this.MenuList.indexOf(this.activeName) + 1 == 6) {
          this.GetCustomTable(5);
        } else {
          this.GetCustomTable(6);
        }
      });
    },
    addTree(ids) { },
    editTree({ newName, treeNode }) { },
    delTree(id) { },
    ChangeTreeIds(ids, type) { },
    GetTitleSet(i) {
      GetTitleSet({
        params: {
          xid: this.$store.state.xid,
          name: "",
        },
      }).then((res) => {
        this.TableListHead_6 = [
          "设备编号",
          "设备状态",
          "运行速度",
          "核心温度",
          "累计充电次数",
          "电机转速",
        ];
        this.TableListHead_8 = ["时间", "操作设备", "操作人员", "进出场"];
        if (res.Data.length > 0) {
          res.Data.forEach((el) => {
            if (el.tist03 == "装饰装修工程模块") {
              this.MenuList[Number(el.tist04) - 1] = el.tist05;
            } else if (el.tist03 == "装饰装修工程第六模块") {
              this.TableListHead_6[Number(el.tist04) - 1] = el.tist05;
            } else if (el.tist03 == "装饰装修工程第八模块") {
              this.TableListHead_8[Number(el.tist04) - 1] = el.tist05;
            }
          });
        }

        if (this.MenuList.indexOf(this.activeName) + 1 == 1) {
          this.GetChartsData(10);
        } else if (this.MenuList.indexOf(this.activeName) + 1 == 2) {
          this.GetChartsData(11);
        } else if (this.MenuList.indexOf(this.activeName) + 1 == 3) {
          this.GetChartsData(12);
        } else if (this.MenuList.indexOf(this.activeName) + 1 == 4) {
          this.GetMultimedia();
        } else if (this.MenuList.indexOf(this.activeName) + 1 == 5) {
          this.GetChartsData(13);
        } else if (this.MenuList.indexOf(this.activeName) + 1 == 6) {
          this.GetCustomTable(5);
        } else if (this.MenuList.indexOf(this.activeName) + 1 == 7) {
          this.GetChartsData(14);
        } else if (this.MenuList.indexOf(this.activeName) + 1 == 8) {
          this.GetCustomTable(6);
        } else {
          this.GetChartsData(10);
        }

        if (!i) {
          this.activeName = this.MenuList[0];
        }

        // this.GetCustomTable(10);
      });
    },
    GetCustomTable(type) {
      GetCustomTable({
        params: {
          xid: this.$store.state.xid,
          cmtb03: type,
          searchword: this.query,
          pageSize: 999,
          pageIndex: 1,
        },
      }).then((res) => {
        this.tableData = res.Data.list;
      });
    },
  },
  created() {
    this.GetTitleSet();
  },
  mounted() { },
  beforeDestroy() { },
};
</script>
<style lang="scss" scoped>
.el-dialog__body,
.home {
  min-height: 500px;
}
</style>
